import React from 'react';
import { List } from 'immutable';
import { Paragraph } from '@uncinc/react-drupal-core';

import './style.scss';

const ParagraphAccordion = ({ entity, className }) => {
  return (
    <div className={`Paragraph paragraph--text ${className}`}>
      <h2>{entity.getIn(['field_title', 0, 'value'])}</h2>
      {entity.get('field_paragraphs') ? (
        entity.get('field_paragraphs', List()).map((paragraph) => {
          const id = paragraph.get('target_id');
          const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);

          return (
            <Paragraph
              key={`paragraph:${id}:${language}`}
              id={id}
              entity={paragraph.get('entity')}
            />
          );
        })
      ) : null}
    </div>
  );
};

export default ParagraphAccordion;
